/**
 * Helper (pure) ของ "role ของผู้ใช้ในโปรเจกต์" — ใช้ตัดสินว่าหน้าเว็บควรยิง endpoint ที่ต้องเป็น editor เองหรือไม่
 *
 * ทำไมต้องมี: API เขียนทุกตัวของ MeGen ต้องเป็น editor (require_run_permission(..., require_editor=True)
 * ⇒ 403 "Editor role required") แต่หน้าบ้านไม่เคยเช็ค role เลย — auto-save ของ Direct Script จึงยิง
 * POST /script2vdo/{id}/update เองตอนเปิด run แม้ผู้ใช้เป็นแค่ viewer ของโปรเจกต์ที่แชร์มา (โดน 403 ทุกครั้งที่เปิด)
 *
 * role มาจากหลังบ้าน 3 ทาง: GET /projects และ GET /projects/{id} คืน "editor" | "viewer" (เจ้าของได้ "editor"),
 * ส่วน POST /projects (สร้างโปรเจกต์ใหม่) คืน "owner" และค่านั้นค้างอยู่ใน selectedProject จนกว่า GET /projects/{id} จะมา
 */

/** role ที่หน้าบ้านได้จากหลังบ้าน — เป็น string กว้าง ๆ เพราะ type ProjectSerializer.role ยังไม่รู้จัก "owner" */
export type ProjectRole = string | null | undefined;

/**
 * viewer เท่านั้นที่แก้ไม่ได้ — role อื่น (editor / owner) หรือยังไม่รู้ role = แก้ได้ (พฤติกรรมเดิม หลังบ้านยังเป็นคนตัดสินจริง)
 * ห้ามเปลี่ยนเป็น `=== "editor"`: จะทำให้เจ้าของที่เพิ่งสร้างโปรเจกต์ (role "owner") auto-save ไม่ได้ชั่วคราว
 */
export const canEditProject = (role: ProjectRole): boolean => role !== "viewer";
